<template>
  <div>
    <switcher-aziende />
    <PageTagline :is_ref_azi_area="true" :elements="tagline_elem"/>

      <div class="d-flex justify-content-center">
        <b-row cols-lg="4" cols-md="4" cols-sm="2" class="justify-content-start" style="gap: 1rem; width: 100%" >

          <b-card v-for="(card, index) in ordered_card_affiliates" :key="index + card.text"
                  no-body
                  img-alt="Image"
                  img-top
                  footer-class="footerStyle"
                  class="text-center card-flex"
                  footer-tag="footer"
          >
            <b-card-img  style="cursor: pointer; height: 170px" @click="openFile(card.link)" :src="card.img"></b-card-img>
            <template v-slot:footer>
              <div class="d-flex justify-content-center">
                <div  style="cursor: default" class="d-flex justify-content-center w-100 align-items-center">
                  <span>{{card.text}}</span>
                  <b-icon class="ml-2 position-absolute" style="cursor: pointer; right: 2%" @click.stop v-if="card.csv" icon="file-earmark-text" @click="downLoadCsv(card.csv)"></b-icon>
                </div>
              </div>
            </template>

          </b-card>

          <b-card v-for="(card, index) in ordered_card" :key="index + card.text"
                  no-body
                  img-alt="Image"
                  img-top
                  footer-class="footerStyle"
                  class="text-center card-flex"
                  footer-tag="footer"
          >
            <b-card-img  style="cursor: pointer; height: 170px" @click="openFile(card.link)" :src="card.img"></b-card-img>
            <template v-slot:footer>
              <div class="d-flex justify-content-center">
                <div  style="cursor: default" class="d-flex justify-content-center w-100 align-items-center">
                  <span>{{card.text}}</span>
                  <b-icon class="ml-2 position-absolute" style="cursor: pointer; right: 2%" @click.stop v-if="card.csv" icon="file-earmark-text" @click="downLoadCsv(card.csv)"></b-icon>
                </div>
              </div>
            </template>

          </b-card>

        </b-row>
  </div>
  </div>

</template>

<script>
import PageTagline from "@/components/PageTagline.vue";
import SwitcherAziende from "@/components/refaziendale/SwitcherAziende.vue";
import { customerStylesMixin } from '@/mixins/customerStylesMixin'

export default {
  name: "BuoniPasto",
  mixins: [ customerStylesMixin ],
  data() {
    return {
      tagline_elem: [{text: 'Buoni Pasto', link: 'office-ref-azi-buoni-pasto'}],
      //tutte le card da inserire
      card_value: [{
        text: 'Repas',
        img: require('@/assets/buoni_pasto/Buono_pasto_Repas.jpg',),
        link: "https://userportal.welfarebit.it/media/docs/Docs_Buoni_Pasto_Repas.pdf",
        csv: "https://userportal.welfarebit.it/media/docs/REPAS_RETE_NAZIONALE-Sett_2025.xlsx"
      }, {
        text: 'Pellegrini',
        img: require('@/assets/buoni_pasto/immagine_pellegrini.jpg'),
        link: "https://userportal.welfarebit.it/media/docs/Docs_Buoni_Pasto_Pellegrini.pdf"
      }
      ],
      //tutte le card di aziende affiliate
      card_value_affiliates: [{
        text: 'Welfarebit powered by Toduba',
        img: require('@/assets/buoni_pasto/buono_pasto_Welfarebit-Toduba.jpg'),
        link: "https://userportal.welfarebit.it/media/docs/Docs_Buoni_Pasto_Toduba.pdf"
      },
      ]
    }
  },
  methods: {
    openFile: function(link) {
      window.open(link, '_blank');
    },
    downLoadCsv: function(url) {

      const link = document.createElement("a");
      link.href = url;
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  },
  computed: {
    //ordered_card e ordered_card_affiliates restituiscono i due array ordinitai per le card delle aziende affiliate e non
    ordered_card: function() {
      if(!this.card_value) return []

      return this.card_value.toSorted((a, b) => a.text.localeCompare(b.text));
    },
    ordered_card_affiliates: function() {
      if(!this.card_value_affiliates) return []

      return this.card_value_affiliates.toSorted((a, b) => a.text.localeCompare(b.text))
    },
  },
  components: {PageTagline, SwitcherAziende},
}
</script>

<style scoped>
.footerStyle {
  background-color: rgb(55, 63, 102);
  color: #fff;
  height: 100%;
  align-content: center;
}

/* Flex card con larghezza calcolata e gap gestito */
@media (min-width: 1200px) {
  .card-flex {
    flex: 0 0 calc(24.7% - 0.5rem); /* Approssimazione */
  }
}

@media  (min-width: 781px) and (max-width: 1199px){
  .card-flex {
    flex: 1 1 calc((100% - 1rem) / 3);
    min-width: 31.7%;
  }
}

@media (max-width: 780px) {
  .card-flex {
    flex: 0 0 calc(50% - 0.5rem); /* 2 card per riga */
  }
}

@media (max-width: 576px) {
  .card-flex {
    flex: 0 0 100%; /* 1 card per riga */
  }
}

</style>